import { Accordion } from "react-bootstrap";
import PropertyLandMarineAndBird from "./CommonFields/PropertyLandMarineAndBird";

function AddBird({ jobList }) {
  return (
    <Accordion className="footage-accordian">
      {jobList &&
        jobList.birds &&
        jobList.birds.length > 0 &&
        jobList.birds.map((value, index) => {
          return (
            <PropertyLandMarineAndBird
              FootageType={"Add Birds"}
              value={value}
              index={index}
            />
          );
        })}
    </Accordion>
  );
}

export default AddBird;
